import type { QueryClient } from '@tanstack/react-query';

import { QUERY_KEY_CONST } from '@/constant';

import type { WebSocketMessage, WebSocketPayload } from './type';

export const onMiriTaskBaseHandler = (
  message: WebSocketMessage<'MiriTask' | 'MiriAlarmLog'>,
  queryClient: QueryClient,
) => {
  const { eventType } = message;

  if (
    eventType === 'MiriTask' ||
    (eventType === 'MiriAlarmLog' &&
      (message.payload as WebSocketPayload<'MiriAlarmLog'>).alarmType.match(
        'MiriTask',
      ))
  ) {
    const queryKeyList = [
      QUERY_KEY_CONST.PROJECT_KEYS.getDetail(),
      QUERY_KEY_CONST.PROJECT_KEYS.getList(),
      QUERY_KEY_CONST.PROJECT_KEYS.getCount(),
      QUERY_KEY_CONST.TASK_KEYS.getList(),
      QUERY_KEY_CONST.TASK_KEYS.getDetail(),
      QUERY_KEY_CONST.TASK_KEYS.getCount(),
      QUERY_KEY_CONST.FRAME_KEYS.getList(),
      QUERY_KEY_CONST.FRAME_KEYS.getCount(),
    ];

    queryKeyList.forEach(queryKey =>
      queryClient.invalidateQueries({ queryKey }),
    );
  }

  return;
};

export const onMiriFrameBaseHandler = (
  message: WebSocketMessage,
  queryClient: QueryClient,
) => {
  const { eventType } = message;

  if (eventType !== 'MiriFrame') return;

  const queryKeyList = [
    QUERY_KEY_CONST.PROJECT_KEYS.getDetail(),
    QUERY_KEY_CONST.PROJECT_KEYS.getList(),
    QUERY_KEY_CONST.PROJECT_KEYS.getCount(),
    QUERY_KEY_CONST.TASK_KEYS.getList(),
    QUERY_KEY_CONST.TASK_KEYS.getDetail(),
    QUERY_KEY_CONST.TASK_KEYS.getCount(),
    QUERY_KEY_CONST.FRAME_KEYS.getList(),
    QUERY_KEY_CONST.FRAME_KEYS.getDetail(),
    QUERY_KEY_CONST.FRAME_KEYS.getCount(),
  ];

  queryKeyList.forEach(queryKey => queryClient.invalidateQueries({ queryKey }));

  return;
};

export const onMiriFrameBulkUpdateBaseHandler = (
  message: WebSocketMessage,
  queryClient: QueryClient,
) => {
  const { eventType } = message;

  if (eventType !== 'MiriBulkUpdateFrameState') return;

  const queryKeyList = [
    QUERY_KEY_CONST.FRAME_KEYS.getList(),
    QUERY_KEY_CONST.FRAME_KEYS.getCount(),
  ];

  queryKeyList.forEach(queryKey => queryClient.invalidateQueries({ queryKey }));

  return;
};

export const onMiriDetroitModelTrainingBaseHandler = (
  message: WebSocketMessage,
  queryClient: QueryClient,
) => {
  const { eventType } = message;

  if (eventType !== 'MiriDetroitModelTraining') return;

  const queryKeyList = [
    QUERY_KEY_CONST.MODELING_KEYS.getList(),
    QUERY_KEY_CONST.MODELING_KEYS.getCount(),
  ];

  queryKeyList.forEach(queryKey => queryClient.invalidateQueries({ queryKey }));
};
